@if (isOpen()) {
  <div
    class="flex flex-row w-[100dvw] h-[100dvh] fixed top-0 left-0 bg-[#9f9f9f9c] justify-center items-center z-45"
  >
    <div
      class="modal-panel flex flex-col rounded-xxl shadow-lg bg-surface z-50 gap-2 p-4"
      [class.modal-panel-large]="size() === 'large'"
    >
      <div class="flex flex-row w-full justify-between">
        <span class="text-sm font-bold">{{title()}}</span>
        @if (closable()) {
          <button
            type="button"
            (click)="close.emit()"
            class="w-6 h-6 rounded-full cursor-pointer flex justify-center items-center border border-nav-dark text-nav-dark hover:border-red-500 hover:text-red-500"
            aria-label="Close modal"
          >
            <i class="fa fa-times text-sm" aria-hidden="true"></i>
          </button>
        }
      </div>
      <ng-content></ng-content>
    </div>
  </div>
}
